module.exports = __webpack_public_path__ + "img/cd644caf6d7cf7b567a11e43aaac1b34.png";